import Header from '@components/Header';
import Loading from '@components/Loading';
import { PaymentErrorType } from '@models/error';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import usePaymentFailed from './hooks/usePaymentFailed';

interface Params {
    type: PaymentErrorType;
    payload: string;
}

const PaymentFailedActivity : ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { t } = useTranslation('errors');
    usePaymentFailed(params);
    return (
        <AppScreen>
            <Header title={t('paymentFailed.title')} />
            <Loading/>
        </AppScreen>
    );
};

export default PaymentFailedActivity;
